import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const Swipable = ({ dataKeys, onTabChange, tabValue, children }) => {
  const [touchStartX, setTouchStartX] = useState(0);
  const [initialOffsetX, setInitialOffsetX] = useState(0);
  const [beingTouched, setBeingTouched] = useState(false);
  const [swipeThreshold] = useState(50);

  const handleTouchStart = (event) => {
    setTouchStartX(event.targetTouches[0]?.clientX);
    setInitialOffsetX(event.currentTarget.offsetLeft);
    setBeingTouched(true);
  };

  const handleTouchEnd = (event) => {
    if (beingTouched) {
      const touchCurrentX = event.changedTouches[0]?.clientX;
      let dX = touchCurrentX - touchStartX + initialOffsetX;
      if (dX > swipeThreshold) {
        //swiped right, go down a tab
        if (tabValue != dataKeys.length - 1) {
          onTabChange(tabValue + 1);
        }
        setBeingTouched(false);
      } else if (dX < -swipeThreshold) {
        //swiped left, go up a tab
        if (tabValue != 0) {
          onTabChange(tabValue - 1);
        }
        setBeingTouched(false);
      }
    }
  };

  return (
    <Grid
      item
      container
      onTouchStart={(event) => handleTouchStart(event)}
      onTouchEnd={(event) => handleTouchEnd(event)}
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
    >
      {children}
    </Grid>
  );
};

Swipable.propTypes = {
  dataKeys: PropTypes.array.isRequired,
  onTabChange: PropTypes.func.isRequired,
  tabValue: PropTypes.number.isRequired,
  horizontalSwipe: PropTypes.bool,
  children: PropTypes.array.isRequired,
};

Swipable.defaultProps = {
  horizontalSwipe: false,
};

export default Swipable;
